import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Box, Button } from "@material-ui/core";
import {
  OutlinedInput,
  ListItemText,
  TextField,
  Select,
  InputAdornment,
  Checkbox,
  FormControlLabel,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import axios from "axios";
import { useSelector } from "react-redux";
import * as env from "../utils/EnvVars";
import TopicName from "../components/TopicName";
import KeywordName from "../components/KeywordName";
import GradeName from "../components/GradeName";
import DifficultyName from "../components/DifficultyName";
import ExamType from "../components/ExamType";
import Country from "../components/Country";
import Tags from "../components/Tags";
import Language from "../components/Language";
import Preview from "../components/Preview";
import { CheckBox } from "@material-ui/icons";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

var vertical = "top",
  horizontal = "center";

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {
  const userObj = useSelector((state) => state.userDetails);
  const [open, setOpen] = React.useState(false);
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [saveLoading, setSaveLoading] = React.useState(false);

  const alphaArr = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];

  const [shuffle, setShuffle] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  const [questionType, setQuestionType] = React.useState(7);

  const [templateTitle, setTemplateTitle] = React.useState("");
  const [treeviewTemplateId, setTreeviewTemplateId] = React.useState(0);
  const [treeviewTemplateTitle, setTreeviewTemplateTitle] = React.useState("");
  const [selftestOptionsObjectiveId, setSelftestOptionsObjectiveId] =
    React.useState(0);
  const [selftestOptionsObjectiveTitle, setSelftestOptionsObjectiveTitle] =
    React.useState("");
  const [selftestOptionsSubjectiveId, setSelftestOptionsSubjectiveId] =
    React.useState(0);
  const [selftestOptionsSubjectiveTitle, setSelftestOptionsSubjectiveTitle] =
    React.useState("");
  const [examLimitId, setExamLimitId] = React.useState(0);
  const [examLimitTitle, setExamLimitTitle] = React.useState("");
  const [objectiveQueTypeTempId, setObjectiveQueTypeTempId] = React.useState(0);
  const [objectiveQueTypeTempTitle, setObjectiveQueTypeTempTitle] =
    React.useState("");
  const [subjectiveQueTypeTempId, setSubjectiveQueTypeTempId] =
    React.useState(0);
  const [subjectiveQueTypeTempTitle, setSubjectiveQueTypeTempTitle] =
    React.useState("");
  const [mocktestTemplateId, setMocktestTemplateId] = React.useState(0);
  const [mocktestTemplateTitle, setMocktestTemplateTitle] = React.useState("");
  const [topictestTemplateId, setTopictestTemplateId] = React.useState(0);
  const [topictestTemplateTitle, setTopictestTemplateTitle] =
    React.useState("");

  const [treeviewTemplateList, setTreeviewTemplateList] = React.useState([]);
  const [selftestOptionsObjectiveList, setSelftestOptionsObjectiveList] =
    React.useState([]);
  const [selftestOptionsSubjectiveList, setSelftestOptionsSubjectiveList] =
    React.useState([]);
  const [examLimitList, setExamLimitList] = React.useState([]);
  const [objectiveQueTypeTempList, setObjectiveQueTypeTempList] =
    React.useState([]);
  const [subjectiveQueTypeTempList, setSubjectiveQueTypeTempList] =
    React.useState([]);
  const [mocktestTemplateList, setMocktestTemplateList] = React.useState([]);
  const [topictestTemplateList, setTopictestTemplateList] = React.useState([]);
  const [questionBody, setQuestionBody] = useState("");
  const [explanation, setExplanation] = useState("");
  const [questionTypeId, setQuestionTypeId] = React.useState(1);
  const [questionTypeName, setQuestionTypeName] = React.useState("");

  // states for the dropdown below explanation

  const [topicList, setTopicList] = useState([]);
  const [topicId, setTopicId] = useState(0);
  const [topicName, setTopicName] = useState("");
  const [examType, setExamType] = useState("");
  const [gradeList, setGradeList] = useState([]);
  const [gradeName, setGradeName] = useState("");
  const [gradeId, setGradeId] = useState(0);
  const [difficultyList, setDifficultyList] = useState([]);
  const [difficultyName, setDifficultyName] = useState("");
  const [difficultyId, setDifficultyId] = useState(0);
  const [languageList, setLanguageList] = useState([]);
  const [languageName, setLanguageName] = useState("");
  const [languageId, setLanguageId] = useState(0);
  const [countryList, setCountryList] = useState([]);
  const [countryName, setCountryName] = useState("");
  const [countryId, setCountryId] = useState(0);
  const [tags, setTags] = useState([]);
  const [keyword, setKeyword] = useState([]);
  const [formattedKeyword, setFormattedKeyword] = useState("");
  const [personName, setPersonName] = React.useState([]);
  const [formattedTags, setFormattedTags] = useState("");

  React.useImperativeHandle(ref, () => ({
    handleClickOpen() {
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert() {
    setShowAlert(false);
  }

  // handle Change for the dropdowns

  const handleTopicChange = (selectedTopic) => {
    if (selectedTopic === null) {
      setTopicId(0);
      setTopicName("");
    }
    setTopicId(selectedTopic?.topicId || 0);
    setTopicName(selectedTopic?.topicName || "");
  };

  const handleGrade = (event) => {
    let val = event.target.value;
    let valArr = val.split("#");
    setGradeId(valArr[0]);
    setGradeName(valArr[1]);
  };

  const handleDifficulty = (event) => {
    let val = event.target.value;
    let valArr = val.split("#");
    console.log(valArr);
    setDifficultyId(valArr[0]);
    setDifficultyName(valArr[1]);
  };

  const handleLanguageChange = (event) => {
    setLanguageName(event.target.value);
  };

  const handleCountryChange = (event) => {
    setCountryName(event.target.value);
  };

  const handleExamTypeChange = (event) => {
    setExamType(event.target.value);
  };

  React.useEffect(() => {
    setRows([]);
    // if (open && userObj) {
    //   createOption(7);
    // }
    if (open) {
      createOption(7);
      getData();
    }

    if (open && props.dataObj && props.dataObj.autoId) {
      setQuestionTypeId(props.dataObj.questionTypeId);
      setQuestionBody(props.dataObj.questionBankSet.questionBody);
      let questionName = encodeURIComponent(
        props.dataObj.questionBankSet.questionType
      );
      setQuestionTypeName(questionName);
      setGradeName(props.dataObj.gradeName);
      setExplanation(props.dataObj.questionBankSet.explanations);
      const responseChoices = props.dataObj.questionBankSet.responseChoice.map(
        (choice) => {
          return {
            responseId: choice.responseId, // Assuming you want to assign an ID to each response option
            responseText: choice.responseText,
          };
        }
      );
      setRows(responseChoices);
      setPersonName(props.dataObj.questionBankSet.correctResponse.split("~"));
      setTopicId(props.dataObj.topicId);
      setTopicName(props.dataObj.topicName);
      const keywordsArray = props.dataObj.keywordNames
        .split(",")
        .filter((keyword) => keyword.trim() !== "");
      setKeyword(keywordsArray);
      setFormattedKeyword(props.dataObj.keywordNames);
      setGradeId(props.dataObj.gradeId);
      setDifficultyId(props.dataObj.difficultyId);
      setDifficultyName(props.dataObj.difficultyName);
      setExamType(props.dataObj.examType);
      setLanguageName(props.dataObj.language);
      setCountryName(props.dataObj.country);
      const TagsArray = props.dataObj.tags
        .split(",")
        .filter((tag) => tag.trim() !== "");
      setTags(TagsArray);
      setFormattedTags(props.dataObj.tags);
      setShuffle(
        props.dataObj.questionBankSet.responseChoiceShuffle === "Yes"
          ? true
          : false
      );
    } else {
      setQuestionTypeId(7);
      setQuestionTypeName("");
      setQuestionBody("");
      setPersonName([]);
      setExamType("");
      setExplanation("");
      setRows([]);
      setTopicId(0);
      setTopicName("");
      setKeyword([]);
      setGradeId(0);
      setGradeName("");
      setDifficultyId(0);
      setDifficultyName("");
      setLanguageName("");
      setCountryName("");
      setTags([]);
      setShuffle(false);
    }

    // if (open && props.dataObj && props.dataObj.autoId) {
    //   setTemplateTitle(props.dataObj.templateTitle);
    //   setTreeviewTemplateId(props.dataObj.treeviewTemplateId);
    //   setTreeviewTemplateTitle(props.dataObj.treeviewTemplateTitle);
    //   setSelftestOptionsObjectiveId(props.dataObj.selftestOptionsObjectiveId);
    //   setSelftestOptionsObjectiveTitle(
    //     props.dataObj.selftestOptionsObjectiveTitle
    //   );
    //   setSelftestOptionsSubjectiveId(props.dataObj.selftestOptionsSubjectiveId);
    //   setSelftestOptionsSubjectiveTitle(
    //     props.dataObj.selftestOptionsSubjectiveTitle
    //   );
    //   setExamLimitId(props.dataObj.examLimitId);
    //   setExamLimitTitle(props.dataObj.examLimitTitle);
    //   setObjectiveQueTypeTempId(props.dataObj.objectiveQueTypeTempId);
    //   setObjectiveQueTypeTempTitle(props.dataObj.objectiveQueTypeTempTitle);
    //   setSubjectiveQueTypeTempId(props.dataObj.subjectiveQueTypeTempId);
    //   setSubjectiveQueTypeTempTitle(props.dataObj.subjectiveQueTypeTempTitle);
    //   setMocktestTemplateId(props.dataObj.mocktestTemplateId);
    //   setMocktestTemplateTitle(props.dataObj.mocktestTemplateTitle);
    //   setTopictestTemplateId(props.dataObj.topictestTemplateId);
    //   setTopictestTemplateTitle(props.dataObj.topictestTemplateTitle);
    // } else {
    //   setQuestionType(7);
    //   setTemplateTitle("");
    //   setTreeviewTemplateId(0);
    //   setTreeviewTemplateTitle("");
    //   setSelftestOptionsObjectiveId(0);
    //   setSelftestOptionsObjectiveTitle("");
    //   setSelftestOptionsSubjectiveId(0);
    //   setSelftestOptionsSubjectiveTitle("");
    //   setExamLimitId(0);
    //   setExamLimitTitle("");
    //   setObjectiveQueTypeTempId(0);
    //   setObjectiveQueTypeTempTitle("");
    //   setSubjectiveQueTypeTempId(0);
    //   setSubjectiveQueTypeTempTitle("");
    //   setMocktestTemplateId(0);
    //   setMocktestTemplateTitle("");
    //   setTopictestTemplateId(0);
    //   setTopictestTemplateTitle("");
    // }
  }, [props.dataObj, open]);

  const getData = async () => {
    try {
      let endpoint1 = env.API_KEY + "/topics-list";
      let endpoint2 = env.API_KEY + "/languages-list";
      let endpoint3 = env.API_KEY + "/country-list";
      let endpoint4 = env.API_KEY + "/difficulty-list";
      let endpoint5 = env.API_KEY + "/grades-list";

      const axiosrequest1 = axios.get(endpoint1);
      const axiosrequest2 = axios.get(endpoint2);
      const axiosrequest3 = axios.get(endpoint3);
      const axiosrequest4 = axios.get(endpoint4);
      const axiosrequest5 = axios.get(endpoint5);

      let [response1, response2, response3, response4, response5] =
        await axios.all([
          axiosrequest1,
          axiosrequest2,
          axiosrequest3,
          axiosrequest4,
          axiosrequest5,
        ]);
      setTopicList(response1?.data?.obj);
      setLanguageList(response2?.data?.obj);
      setCountryList(response3?.data?.obj);
      setDifficultyList(response4?.data?.obj);
      setGradeList(response5?.data?.obj);
    } catch (error) {
      console.log("error");
    }
  };

  async function getApiData() {
    let axiosHeader = {
      headers: {
        "Content-Type": "multipart/mixed",
        loginId: userObj.loginId,
        token: userObj.token,
        device: "web",
      },
    };
    let endpoints1 =
      env.API_EXAM_SERVICE +
      "/topic-service/read/topics-templates?sortby=templateName&maxRows=50000";
    let endpoints2 =
      env.API_EXAM_SERVICE +
      "/exams/read/selftest-options-objective?sortby=templateTitle&maxRows=50000";
    let endpoints3 =
      env.API_EXAM_SERVICE +
      "/exams/read/selftest-options-subjective?sortby=templateTitle&maxRows=50000";
    let endpoints4 =
      env.API_EXAM_SERVICE +
      "/exams/read/exam-limits-templates?sortby=templateTitle&maxRows=50000";
    let endpoints5 =
      env.API_EXAM_SERVICE +
      "/exams/read/selftest-options-objective?sortby=templateTitle&maxRows=50000";
    let endpoints6 =
      env.API_EXAM_SERVICE +
      "/exams/read/selftest-options-subjective?sortby=templateTitle&maxRows=50000";
    let endpoints7 =
      env.API_EXAM_SERVICE +
      "/exams/read/mocktest-templates?sortby=templateTitle&maxRows=50000";
    let endpoints8 =
      env.API_EXAM_SERVICE +
      "/exams/read/topictest-templates?sortby=templateTitle&maxRows=50000";

    const axiosrequest1 = axios.get(endpoints1, axiosHeader);
    const axiosrequest2 = axios.get(endpoints2, axiosHeader);
    const axiosrequest3 = axios.get(endpoints3, axiosHeader);
    const axiosrequest4 = axios.get(endpoints4, axiosHeader);
    const axiosrequest5 = axios.get(endpoints5, axiosHeader);
    const axiosrequest6 = axios.get(endpoints6, axiosHeader);
    const axiosrequest7 = axios.get(endpoints7, axiosHeader);
    const axiosrequest8 = axios.get(endpoints8, axiosHeader);

    await axios
      .all([
        axiosrequest1,
        axiosrequest2,
        axiosrequest3,
        axiosrequest4,
        axiosrequest5,
        axiosrequest6,
        axiosrequest7,
        axiosrequest8,
      ])
      .then(
        axios.spread(function (res1, res2, res3, res4, res5, res6, res7, res8) {
          setTreeviewTemplateList(res1.data.list);
          setSelftestOptionsObjectiveList(res2.data.list);
          setSelftestOptionsSubjectiveList(res3.data.list);
          setExamLimitList(res4.data.list);
          setObjectiveQueTypeTempList(res5.data.list);
          setSubjectiveQueTypeTempList(res6.data.list);
          setMocktestTemplateList(res7.data.list);
          setTopictestTemplateList(res8.data.list);
        })
      );
  }

  let questionJson = {
    questionType: questionTypeName.split("%20").join(" "),
    commonDataDescription: null,
    questionBody: questionBody,
    columns: null,
    responseChoiceShuffle: shuffle ? "Yes" : "No",
    responseChoice: rows?.map((el) => {
      let obj = {};
      obj.responseId = el.responseId;
      obj.responseText = el.responseText;
      return obj;
    }),
    correctResponse: personName.join("~"),
    explanations: explanation,
  };

  console.log(personName, "personName");

  function handleSave() {
    if (!questionTypeName) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select Question Type");
      return false;
    } else if (!questionBody) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter Question");
      return false;
    } else if (!topicName) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select Topic");
      return false;
    } else if (!gradeName) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select Grade Name");
      return false;
    } else if (!examType) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select Exam Type");
      return false;
    } else if (!languageName) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select language");
      return false;
    }

    if (
      questionTypeName &&
      questionBody &&
      questionBody.length > 1 &&
      topicName &&
      gradeName &&
      examType &&
      languageName
    ) {
      setSaveLoading(true);

      let axiosHeader = {
        headers: {
          "Content-Type": "multipart/mixed",
          // loginId: userObj.loginId,
          // token: userObj.token,
          // device: "web",
        },
      };
      const data = new FormData();
      if (props.dataObj && props.dataObj.autoId) {
        data.append("id", props.dataObj.autoId);
        data.append("questionTypeId", questionTypeId);
        data.append("questionJson", JSON.stringify(questionJson));
        data.append("questionType", questionTypeName.split("%20").join(" "));
        data.append("topicId", topicId);
        data.append("topicName", topicName);
        data.append("keywordNames", formattedKeyword);
        data.append("gradeId", gradeId);
        data.append("gradeName", gradeName);
        data.append("difficultyId", difficultyId);
        data.append("difficultyName", difficultyName);
        data.append("examType", examType);
        data.append("language", languageName);
        data.append("country", countryName);
        data.append("tags", formattedTags);
      } else {
        data.append("questionTypeId", questionTypeId);
        data.append("questionJson", JSON.stringify(questionJson));
        data.append("questionType", questionTypeName.split("%20").join(" "));
        data.append("topicId", topicId);
        data.append("topicName", topicName);
        data.append("keywordNames", formattedKeyword);
        data.append("gradeId", gradeId);
        data.append("gradeName", gradeName);
        data.append("difficultyId", difficultyId);
        data.append("difficultyName", difficultyName);
        data.append("examType", examType);
        data.append("language", languageName);
        data.append("country", countryName);
        data.append("tags", formattedTags);
      }

      // private String commonDataDescription;
      // private String questionBody;
      // private List<BeanColumns> columns;
      // private List<BeanResponseChoice> answerOption;
      // private Boolean answerOptionShuffle;
      // private String correctAnswer;
      // private String explanation;

      //let questionJson = {'commonDataDescription':'','questionBody':questionBody, 'columns':rows, 'answerOption':rows, 'answerOptionShuffle':'', 'correctAnswer':correctAnswer, 'explanation':explanation};

      // data.append("answerOption", JSON.stringify(rows));
      // data.append("correctAnswer", correctAnswer);
      // data.append("explanation", explanation);

      // if (shuffle) {
      //   data.append("shuffle", 1);
      // } else {
      //   data.append("shuffle", 0);
      // }

      let apiURL = "/admin-questionbanks-create";
      let myMessage = "Question has been created.";
      if (props.dataObj != null && props.dataObj.autoId) {
        apiURL = "/admin-questionbanks-update";
        myMessage = "Question has been updated.";
      }

      axios
        .post(env.API_KEY + apiURL, data, axiosHeader)
        .then((response) => {
          setSaveLoading(false);
          props.updatedList(response);
          //console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
          if (response.data.responseTxt === "success") {
            setSeverityAlert("success");
            setOpen(false);
            setShowAlert(true);
            setAlertMessage(myMessage);
            window.location.reload();
            // props.updatedList(response.data.list);
            return false;
          } else if (response.data.responseTxt === "alreadyexistserror") {
            setSeverityAlert("error");
            setOpen(true);
            setShowAlert(true);
            setAlertMessage(
              "This template name was created earlier. Enter another template name"
            );
            return false;
          } else {
            setSeverityAlert("error");
            setShowAlert(true);
            setAlertMessage("This template could not be saved.");
            return false;
          }
        })
        .catch((error) => {
          console.log("ERROR: ", error);
        });
    }
  }

  function saveData() {
    if (!templateTitle) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter exam title");
      return false;
    }

    if (templateTitle && templateTitle.length > 1) {
      setSaveLoading(true);

      let axiosHeader = {
        headers: {
          "Content-Type": "multipart/mixed",
          loginId: userObj.loginId,
          token: userObj.token,
          device: "web",
        },
      };
      const data = new FormData();
      if (props.dataObj && props.dataObj.autoId) {
        data.append("id", props.dataObj.autoId);
      }
      data.append("templateTitle", templateTitle);
      data.append("treeviewTemplateId", treeviewTemplateId);
      data.append("treeviewTemplateTitle", treeviewTemplateTitle);
      data.append("selftestOptionsObjectiveId", selftestOptionsObjectiveId);
      data.append(
        "selftestOptionsObjectiveTitle",
        selftestOptionsObjectiveTitle
      );
      data.append("selftestOptionsSubjectiveId", selftestOptionsSubjectiveId);
      data.append(
        "selftestOptionsSubjectiveTitle",
        selftestOptionsSubjectiveTitle
      );
      data.append("examLimitId", examLimitId);
      data.append("examLimitTitle", examLimitTitle);
      data.append("objectiveQueTypeTempId", objectiveQueTypeTempId);
      data.append("objectiveQueTypeTempTitle", objectiveQueTypeTempTitle);
      data.append("subjectiveQueTypeTempId", subjectiveQueTypeTempId);
      data.append("subjectiveQueTypeTempTitle", subjectiveQueTypeTempTitle);
      data.append("mocktestTemplateId", mocktestTemplateId);
      data.append("mocktestTemplateTitle", mocktestTemplateTitle);
      data.append("topictestTemplateId", topictestTemplateId);
      data.append("topictestTemplateTitle", topictestTemplateTitle);

      let apiURL = "/exams/create/exam-templates";
      let myMessage = "Template name has been created.";
      if (props.dataObj != null && props.dataObj.autoId) {
        apiURL = "/exams/update/exam-templates";
        myMessage = "Template name has been updated.";
      }

      axios
        .post(env.API_EXAM_SERVICE + apiURL, data, axiosHeader)
        .then((response) => {
          setSaveLoading(false);
          //console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
          if (response.data.responseTxt === "success") {
            setSeverityAlert("success");
            setOpen(false);
            setShowAlert(true);
            setAlertMessage(myMessage);
            props.updatedList(response.data.list);
            return false;
          } else if (response.data.responseTxt === "alreadyexistserror") {
            setSeverityAlert("error");
            setOpen(true);
            setShowAlert(true);
            setAlertMessage(
              "This template name was created earlier. Enter another template name"
            );
            return false;
          } else {
            setSeverityAlert("error");
            setShowAlert(true);
            setAlertMessage("This template could not be saved.");
            return false;
          }
        })
        .catch((error) => {
          console.log("ERROR: ", error);
        });
    }
  }

  function handleTreeview(val) {
    let valArr = val.split("#");
    setTreeviewTemplateId(valArr[0]);
    setTreeviewTemplateTitle(valArr[1]);
  }
  function handleSelftestOptionsObjective(val) {
    let valArr = val.split("#");
    setSelftestOptionsObjectiveId(valArr[0]);
    setSelftestOptionsObjectiveTitle(valArr[1]);
  }
  function handleSelftestOptionsSubjective(val) {
    let valArr = val.split("#");
    setSelftestOptionsSubjectiveId(valArr[0]);
    setSelftestOptionsSubjectiveTitle(valArr[1]);
  }
  function handleExamLimit(val) {
    let valArr = val.split("#");
    setExamLimitId(valArr[0]);
    setExamLimitTitle(valArr[1]);
  }
  function handleObjectiveQueTypeTemp(val) {
    let valArr = val.split("#");
    setObjectiveQueTypeTempId(valArr[0]);
    setObjectiveQueTypeTempTitle(valArr[1]);
  }
  function handleSubjectiveQueTypeTemp(val) {
    let valArr = val.split("#");
    setSubjectiveQueTypeTempId(valArr[0]);
    setSubjectiveQueTypeTempTitle(valArr[1]);
  }
  function handleMocktestTemplate(val) {
    let valArr = val.split("#");
    setMocktestTemplateId(valArr[0]);
    setMocktestTemplateTitle(valArr[1]);
  }
  function handleTopictestTemplate(val) {
    let valArr = val.split("#");
    setTopictestTemplateId(valArr[0]);
    setTopictestTemplateTitle(valArr[1]);
  }

  const handleTagChange = (event, selectedTags) => {
    setTags(selectedTags);
    setFormattedTags(selectedTags.join(","));
  };

  const handleKeywordChange = (event, selectedTags) => {
    setKeyword(selectedTags);
    setFormattedKeyword(selectedTags.join(","));
  };

  const handleAnswerOption = (i, event) => {
    const { value } = event.target;
    setRows((prev) => {
      const updateState = [...prev];
      updateState[i] = {
        ...updateState[i],
        responseId: alphaArr[i],
        responseText: value,
      };
      return updateState;
    });
  };

  console.log(rows, "rows====>>>>>>");

  const addTableRows = () => {
    const rowsInput = {
      responseId: "",
      responseText: "",
    };
    setRows([...rows, rowsInput]);
  };

  function createOption(opt) {
    const rowsInput = {
      responseId: "",
      responseText: "",
    };
    let optArr = [];
    if (7 === opt) {
      for (let i = 0; i < 4; i++) {
        optArr.push(rowsInput);
      }
    }
    setRows(optArr);
  }

  function handleQuestionType(val) {
    // console.log(val)
    let valArr = val.split("#");
    setQuestionTypeId(valArr[0]);
    setQuestionTypeName(valArr[1]);
    createOption(parseInt(valArr[0]));
  }

  console.log(questionTypeName, "questionTypeName");

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  return (
    <>
      <Dialog
        disableEnforceFocus
        fullWidth
        maxWidth="md"
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle
          style={{ marginBottom: "-30px" }}
          onClose={handleClose}
        ></DialogTitle>
        <DialogContent>
          <Box style={{ display: "flex" }}>
            <Grid item md={6} xs={6} className="test-instructions">
              <div className="btmbdrgry">
                <h3>{props.dataObj != null ? <>Edit</> : <>New</>} Question</h3>
              </div>
              <p>
                <table
                  style={{ width: "100%" }}
                  cellSpacing="1"
                  cellPadding="8"
                >
                  <tr>
                    <td>
                      <FormControl fullWidth size="small">
                        <InputLabel id="demo-simple-select-label">
                          Question Type
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={questionTypeId + "#" + questionTypeName}
                          label="Question Type"
                          onChange={(event) =>
                            handleQuestionType(event.target.value)
                          }
                        >
                          {/* <MenuItem value={1} >Multiple Choice</MenuItem>
                                    <MenuItem value={2} >Multiple Choice (5)</MenuItem>
                                    <MenuItem value={3} >MC Assertion Reason</MenuItem>
                                    <MenuItem value={4} >MC Matching Type</MenuItem>
                                    <MenuItem value={5} >Selection Type</MenuItem>
                                    <MenuItem value={6} >Integer Type</MenuItem> */}
                          <MenuItem value={"7#Multiple%20Response"}>
                            Multiple Response
                          </MenuItem>
                          {/* <MenuItem value={8} >MR Matching Type</MenuItem>
                                    <MenuItem value={9} >Common Data</MenuItem>
                                    <MenuItem value={10} >Common Data (5)</MenuItem>
                                    <MenuItem value={11} >True False</MenuItem>
                                    <MenuItem value={12} >Fill in Blank</MenuItem>
                                    <MenuItem value={13} >Subjective Type Very Short</MenuItem>
                                    <MenuItem value={14} >Subjective Type Short Answer I</MenuItem>
                                    <MenuItem value={15} >Subjective Type Short Answer II</MenuItem>
                                    <MenuItem value={16} >Subjective Type Long</MenuItem> */}
                        </Select>
                      </FormControl>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <TextField
                        label="Question Body"
                        // onChange={(event) => setTemplateTitle(event.target.value)}
                        // value={templateTitle}
                        onChange={(event) =>
                          setQuestionBody(event.target.value)
                        }
                        value={questionBody}
                        sx={{ fontSize: 10 }}
                        rows={3}
                        multiline
                        size="small"
                        variant="outlined"
                        fullWidth
                      />
                    </td>
                  </tr>
                  {rows && rows.length > 0
                    ? rows.map((row, i) => (
                        <tr>
                          <td>
                            <TextField
                              label="Option"
                              onChange={(event) => handleAnswerOption(i, event)}
                              value={row?.responseText}
                              sx={{ fontSize: 10 }}
                              size="small"
                              variant="outlined"
                              fullWidth
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <div>{alphaArr[i]}</div>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </td>
                        </tr>
                      ))
                    : null}
                  <tr>
                    <td>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={shuffle}
                            onChange={(event) =>
                              setShuffle(event.target.checked)
                            }
                          />
                        }
                        label="Option Shuffle"
                        style={{ marginTop: -14, marginBottom: -14 }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <FormControl fullWidth size="small">
                        <InputLabel id="demo-multiple-checkbox-label">
                          Correct Answer
                        </InputLabel>
                        <Select
                          labelId="demo-multiple-checkbox-label"
                          id="demo-multiple-checkbox"
                          multiple
                          value={personName}
                          onChange={handleChange}
                          input={<OutlinedInput label="Correct Answer" />}
                          renderValue={(selected) => selected.join(", ")}
                          MenuProps={MenuProps}
                        >
                          {rows && rows.length > 0
                            ? rows.map((row, i) => (
                                <MenuItem key={"a" + i} value={alphaArr[i]}>
                                  <Checkbox
                                    checked={
                                      personName.indexOf(alphaArr[i]) > -1
                                    }
                                  />
                                  <ListItemText primary={alphaArr[i]} />
                                </MenuItem>
                              ))
                            : null}
                        </Select>
                      </FormControl>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <TextField
                        label="Explanation"
                        onChange={(event) => setExplanation(event.target.value)}
                        value={explanation}
                        sx={{ fontSize: 10 }}
                        rows={3}
                        multiline
                        size="small"
                        variant="outlined"
                        fullWidth
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <TopicName
                        topicList={topicList}
                        handleTopicChange={handleTopicChange}
                        topicName={topicName}
                        topicId={topicId}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <KeywordName
                        handleKeywordChange={handleKeywordChange}
                        keyword={keyword}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <GradeName
                        gradeName={gradeName}
                        handleGrade={handleGrade}
                        gradeList={gradeList}
                        gradeId={gradeId}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <DifficultyName
                        difficultyName={difficultyName}
                        handleDifficulty={handleDifficulty}
                        difficultyList={difficultyList}
                        difficultyId={difficultyId}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <ExamType
                        examType={examType}
                        handleExamTypeChange={handleExamTypeChange}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Language
                        languageName={languageName}
                        handleLanguageChange={handleLanguageChange}
                        languageList={languageList}
                        languageId={languageId}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Country
                        countryName={countryName}
                        handleCountryChange={handleCountryChange}
                        countryList={countryList}
                        countryId={countryId}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Tags handleTagChange={handleTagChange} tag={tags} />
                    </td>
                  </tr>

                  {/* <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Topic test</td>
                            <td>
                              <Select 
                                  fullWidth
                                  labelId="select-class-label"
                                  id="select-class"
                                  value={topictestTemplateId+'#'+topictestTemplateTitle}									
                                  onChange={event => handleTopictestTemplate(event.target.value)}
                                  variant="standard"
                                >
                                    <MenuItem value={'0#'} >Select</MenuItem>
                                    {(topictestTemplateList && topictestTemplateList.length>0)?topictestTemplateList.map((row,i)=>(
                                      <MenuItem key={'tchr'+i} value={row.autoId+'#'+row.templateTitle}>{row.templateTitle}</MenuItem>
                                    )):null}
                                </Select>
                            </td>                            
                        </tr> */}
                </table>

                <Box mt={2}>
                  <Button
                    onClick={() => {
                      handleClose();
                    }}
                    style={{ marginRight: 12 }}
                    size="small"
                    variant="outlined"
                  >
                    Cancel
                  </Button>
                  {saveLoading ? (
                    <LoadingButton
                      loading={saveLoading}
                      style={{
                        backgroundColor: "#008000",
                        color: "#FFF",
                        marginRight: 10,
                      }}
                      size="small"
                      variant="contained"
                    >
                      Save
                    </LoadingButton>
                  ) : (
                    <Button
                      onClick={() => {
                        // saveData();
                        handleSave();
                      }}
                      style={{
                        backgroundColor: "#008000",
                        color: "#FFF",
                        marginRight: 10,
                      }}
                      size="small"
                      variant="contained"
                    >
                      Save
                    </Button>
                  )}
                </Box>
              </p>
            </Grid>
            <Grid item md={6} xs={6} spacing={1}>
              <div>
                <div className="btmbdrgry">
                  <h2>Preview</h2>
                </div>
                <Box sx={{ marginTop: "20px" }}>
                  <h4>{questionBody ? "Q." + " " + questionBody : ""}</h4>
                  <ul style={{ listStyleType: "none", padding: 0 }}>
                    {rows?.map((el, i) => (
                      <li key={i}>
                        {el.responseText && (
                          <>
                            <Checkbox />
                            <Typography
                              component="span"
                              style={{ marginRight: "5px" }}
                            >
                              {alphaArr[i] + " ."}
                            </Typography>
                          </>
                        )}
                        {el.responseText}
                      </li>
                    ))}
                  </ul>
                  <br />
                  {explanation && (
                    <Typography component="span">
                      <span sx={{ fontWeight: "bold" }}>Explanation :</span>{" "}
                      {explanation}
                    </Typography>
                  )}
                </Box>
              </div>
              {personName.length > 0 && "Correct Answer :"}
              {personName.length > 0 &&
                personName.map((el) => {
                  return <Typography component="span">{" " + el}</Typography>;
                })}
            </Grid>
          </Box>
        </DialogContent>
      </Dialog>

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={showAlert}
          autoHideDuration={6000}
          onClose={hideAlert}
          anchorOrigin={{ vertical, horizontal }}
        >
          <Alert
            onClose={hideAlert}
            variant="filled"
            severity={severityAlert}
            sx={{ width: "100%" }}
          >
            {alertMessage}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
});

export default CustomizedDialogs;
